import Vue from 'vue'
import VipFirstBuyPopup from './vip-first-buy-popup'

let VipFirstBuyPopupTem = Vue.extend(VipFirstBuyPopup)
let instance
let vipFirstBuyPopup = options => {
  if (!instance) {
    instance = new VipFirstBuyPopupTem({})
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }
  instance.vipBuyStatus = options.vipBuyStatus
  instance.skuInfo = options.skuInfo
  instance.isTrackClick = options.isTrackClick
  instance.callback = options.callback
  // 这里获取数据
  instance.show = true
}
vipFirstBuyPopup.close = () => {
  instance && (instance.show = false)
}
export default vipFirstBuyPopup
